module.exports = __webpack_public_path__ + "static/Drywaller-1ceb88dfb2b54e5c4cd247ce85deba8e.png";